import * as ErrorMessage from "~/ErrorMessage";

export type Status = number;
export namespace Status {
  export const toMessage = (status: Status): string => {
    if (status === 201) return "Created.";
    if (status <= 299) return "Success.";
    if (status <= 399)
      return `Couldn't finish request, ${ErrorMessage.Remedy.contactSupport()}.`;
    if (status === 401)
      return `Log in first then ${ErrorMessage.Remedy.Retry.now()} or ${ErrorMessage.Remedy.contactSupport()}.`;
    if (status === 403)
      return `You aren't allowed to do that, ${ErrorMessage.Remedy.contactSupport()}.`;
    if (status == 404) return "Nothing found.";
    if (status <= 499)
      return `Something is wrong with your request, ${ErrorMessage.Remedy.contactSupport()}.`;
    if (status === 503)
      return `We're having problems, ${ErrorMessage.Remedy.Retry.later()} or ${ErrorMessage.Remedy.contactSupport()}.`;
    if (status <= 599)
      return `We're having problems, ${ErrorMessage.Remedy.contactSupport()}.`;
    return "Done.";
  };
}
